export var cardsContainer = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1em',
  margin: '0 2em 2.5em'
};
export var card = function card(theme) {
  return {
    backgroundColor: theme.white,
    border: "1px solid ".concat(theme.gray100)
  };
};
export var cardHeader = function cardHeader(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1.2em 1.6em',
    borderBottom: "1px solid ".concat(theme.gray100),
    backgroundColor: theme.gray50,
    '& .card-name': {
      fontSize: '1.4rem',
      fontWeight: 600,
      color: theme.gray700
    }
  };
};
export var cardBody = function cardBody(theme) {
  return {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    padding: '1.2em 0',
    '@media (max-width: 600px)': {
      gridTemplateColumns: '1fr 1fr'
    }
  };
};
export var dataField = function dataField(theme) {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.4em',
    padding: '0.4em 1.6em',
    borderRight: "1px solid ".concat(theme.gray100),
    '&:last-of-type': {
      borderRight: 'none'
    },
    '@media (max-width: 600px)': {
      '&:nth-of-type(odd)': {
        borderRight: "1px solid ".concat(theme.gray100)
      },
      '&:nth-last-of-type(-n+2)': {
        borderBottom: 'none'
      }
    }
  };
};
export var fieldLabel = function fieldLabel(theme) {
  return {
    fontSize: '1.1rem',
    color: theme.gray300
  };
};
export var amountValue = function amountValue(theme) {
  return {
    fontSize: '1.4rem',
    fontWeight: 600,
    color: theme.gray700,
    fontVariantNumeric: 'tabular-nums',
    '& .currency': {
      marginLeft: '0.3em',
      fontSize: '1.1rem',
      fontWeight: 400,
      color: theme.gray300
    }
  };
};
export var secondaryAmount = function secondaryAmount(theme) {
  return {
    fontSize: '1.1rem',
    color: theme.gray300,
    fontWeight: 400
  };
};
export var emptyState = function emptyState(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '6rem 2rem',
    color: theme.gray300,
    fontSize: '1.4rem',
    backgroundColor: theme.white,
    border: "1px solid ".concat(theme.gray100),
    margin: '0 2em'
  };
};